import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { toast } from "react-toastify";

import TemplateTable from "../../components/TemplateTable";
import { ITableAppRender } from "../../components/TableApp";
import { INotificacaoListModel } from "../../Repositories/NotificationRepository";
import { IFields } from "../../components/Search/FilterBuilder";
import { ISearch } from "../../components/Search";
import errors from "../../Utils/ExtractErrors";
import { ISearchResponse } from "../../interfaces";
import NotificationRepository from "../../Repositories/NotificationRepository";
import { Button } from "semantic-ui-react";
import ModalYesNo from "../../components/ModalYesNo";
import { Link } from "react-router-dom";
import AdminCadastrarNotificacao from "./AdminCadastrarNotificacao";

interface IState {
    loading: boolean;
    list: INotificacaoListModel[];
}

const initialState: IState = {
    loading: true,
    list: []
}

export default function AdminNotifications() {
    const [state, setState] = useState<IState>(initialState);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setState(state => ({ ...state, loading: true }));
        try {
            let response: ISearchResponse<INotificacaoListModel>;

            if (refSearch.current.type === "simples") {
                response = await NotificationRepository.ListAdmin({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await NotificationRepository.ListAdmin({
                    filter: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setState({ loading: false, list: response.list });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });

            setState(state => ({ ...state, loading: false }));
        }
    }

    function onSearch({ searchString, type }: ISearch) {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;
        load();
    }

    function onChangeRecords(value: number) {
        refRecordsByPage.current = value;
        load();
    }

    function onPageChange(pageNumber: string | number | undefined) {
        refPageNumber.current = pageNumber;
        load();
    }

    async function handleRemove(id: string) {
        try {
            await NotificationRepository.Remove(id);
            load();
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }

    function handleTableActions(data: INotificacaoListModel, index: number) {
        return ([
            <Button
                as={Link}
                to={`/admin/notifications/${data.id}/status`}
                icon="info"
                color="blue"
            />,
            <ModalYesNo
                trigger={<Button icon="trash" color="red" />}
                header="Apagar"
                content="Deseja realmente apagar esta notificação?"
                onSuccess={() => handleRemove(data.id)}
            />
        ]);
    }

    const insertButton = (<AdminCadastrarNotificacao onSuccess={load} />);

    const tableRender: ITableAppRender[] = [
        {
            header: "Data",
            content: (notificacao: INotificacaoListModel) => format(new Date(notificacao.criadaEm), "dd/MM/yyyy"),
            width: 3
        },
        {
            header: "Descrição",
            content: (notificacao: INotificacaoListModel) => notificacao.descricao,
            width: 10
        }
    ];

    const fields: IFields[] = [
        { label: "Data", name: "CriadaEm", type: "date", roles: ["*"] },
        { label: "Descrição", name: "Descricao", type: "string", roles: ["*"] }
    ];

    return (
        <TemplateTable
            title="Notificações"
            icon="bell"
            insert={insertButton}
            searchPlaceHolder="Descrição"
            filterFields={fields}
            onSearch={onSearch}
            tableLoading={state.loading}
            tableList={state.list}
            tableRender={tableRender}
            tableActions={handleTableActions}
            tableOnChangeRecords={onChangeRecords}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalPages: refTotalPages.current,
                totalRecords: refTotalRecords.current,
                onPageChange: onPageChange
            }}
        />
    )
}
